import {Component, Input} from "@angular/core";

@Component({
    selector: "app-search-tip",
    templateUrl: "./search-tip.component.html",
    styleUrls: ["./search-tip.component.css"]
})
export class SearchTipComponent {
    @Input() name: string;
}
